import http from "../helpers/http";
import https from "../helpers/https";

export const getBanks = async () => {
  const response = await http().get("/Settings/GetBanks");
  return response.data;
};

export const getCurrencies = async () => {
  const response = await http().get("/Settings/GetCurrencies");
  return response.data;
};

export const addSettlementAccount = async (payload) => {
  const response = await http().post("/Settings/AddSettlementAccount", payload);
  return response.data;
};

export const getSettlementAccount = async () => {
  const response = await http().get("/Settings/GetSettlementAccount");
  return response.data
};

export const updateProfile = async (payload) => {
  const response = await https().post("/Account/UpdateProfile", payload);
  return response.data;
};

export const updateWebhookUrl = async (payload) => {
  const response = await http().post(
    "/Account/UpdateWebhookUrl/update-webhook-url",
    payload
  );
  return response.data;
};

export const getProfileInfo = async () => {
  const response = await http().get("/Account/GetProfileInformation");
  return response.data;
};

export const getCredentials = async () => {
  const response = await http().get("/Settings/GetCredentials");
  return response.data;
};

export const newRole = async (payload) => {
  const response = await http().post("/Role/CreateRole", payload);
  return response.data;
};

export const getPermissions = async () => {
  const response = await http().get("/Role/GetPermissionList");
  return response.data;
};

export const addPermissionsToRole = async (payload) => {
  const response = await http().post("/Role/AddPermissionsToRole", payload);
  return response.data;
};

export const getRoles = async (payload) => {
  const response = await http().get("/Role/GetRoles");
  return response.data;
};

export const getPermissionsForRole = async (id) => {
  const response = await http().get(`/Role/GetPermissionList/${id}`);
  return response.data;
};

export const changePassword = async (payload) => {
  const response = await http().post("/Account/ChangePassword", payload);
  return response.data;
};
export const inviteMember = async (payload) => {
  const response = await http().post("/User/InviteNewMember", payload);
  return response.data;
};
export const RetrieveNewUser = async (email) => {
  const response = await http().get(
    `/User/RetrieveNewUser?emailAddress=${email}`
  );
  return response.data;
};
export const NewMemberInvite = async (payload) => {
  const response = await http().post(
    "/User/CompleteNewMemberInvitation",
    payload
  );
  return response.data;
};

export const uploadKycDoc = async (payload) => {
  const response = await https().post("/Document/Upload", payload);
  return response.data;
};

export const getDocuments = async (payload) => {
  const response = await http().get("/Document/GetDocuments");
  return response.data;
};

export const downloadKyc = async (docType) => {
  const response = await http().get(
    `/Document/Download?documentType=${docType}`,
    { responseType: "blob" }
  );
  return response.data;
};

export const verifyAccount = async (payload) => {
  const response = await http().post("/Settings/VerifyAccount", payload);
  return response.data;
};

export const toggleState = async (profile) => {
  const res = await http().post(
    `/Account/ToggleProfile`, { profile }
  );
  return res.data;
};

export const deleteDocument = async (id) => {
  const res = await http().get(`/Document/DeleteDocument/${id}`);
  return res.data;
};

export const getBusinessDetails = async () => {
  const response = await http().get("/Merchant/GetBusinessDetails");
  return response.data;
};

export const updateBusiness = async (payload, merchantId) => {
  const response = await http().post(`/Merchant/UpdateBusiness/${merchantId}`, payload);
  return response.data;
};

export const createPaymentLink = async (payload) => {
  const response = await https().post("/PaymentLink/Create", payload);
  return response.data;
};

export const getPaymentLink = async (id) => {
  const response = await http().get(`/PaymentLink/Get/${id}`);
  return response.data;
};

export const getNotification = async () => {
  const response = await http().get("/notification/Index");
  return response.data;
};

export const rotateLiveKey = async () => {
  const response = await http().post("/Account/RotateLiveKey/rotate-live");
  return response.data;
};

export const rotateSandboxKey = async () => {
  const response = await http().post("/Account/RotateSandboxKey/rotate-sandbox");
  return response.data;
};
